import { BuilderEmptyStateView } from '@/components/Common/BuilderEmptyStateView';
import { Box, Button, Typography } from '@mui/material';

export default function MarketPlaceEmptyStateView() {
  return (
    <Box width='100%' minHeight='50vh' display='flex' alignItems='center' justifyContent='center'>
      <BuilderEmptyStateView minHeight={260} iconWidth={220} iconHeight={220} content={<MessageComponent />} />
    </Box>
  );
}

const MessageComponent = () => {
  return (
    <Box display='flex' flexDirection='column' alignItems='center' mt={-5}>
      <Typography fontSize={20} fontWeight={500} color='secondary' textAlign='center'>
        Can't find the integration you need?
      </Typography>
      <Typography mt={1} fontSize={14} fontWeight={400} color='#777777' textAlign='center' mb={2}>
        No worries, we can custom-build this integration for you.
      </Typography>
      <Button
        variant='contained'
        onClick={() => window.open('https://support.kickcall.ai/?b=68f0ab40a77f2a9129036527', '_blank')}
      >
        Drop an Integration Request
      </Button>
    </Box>
  );
};
